<template>
  <div class="login">
    <!-- 背景装饰 -->
    <div class="login-bg-decoration">
      <div class="football-icon football-icon-1"></div>
      <div class="football-icon football-icon-2"></div>
      <div class="football-icon football-icon-3"></div>
      <div class="goal-icon goal-icon-1"></div>
      <div class="goal-icon goal-icon-2"></div>
    </div>

    <div class="container">
      <!-- 头部 -->
      <div class="login-header">
        <div class="close" @click="$router.go(-1)"></div>
        <div class="register-btn" @click="$parent.goNav('/register')">注册</div>
      </div>

      <!-- LOGO -->
      <div class="login-brand">
        <div class="brand-logo">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="28" stroke="#165DFF" stroke-width="2" fill="#F8FAFC"/>
            <path d="M30 10V50" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M10 30H50" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17 17L43 43" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17 43L43 17" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="30" cy="30" r="8" fill="#165DFF" opacity="0.8"/>
          </svg>
        </div>
        <div class="brand-text">
          <h1 class="brand-name">{{ $store.state.appInfo.title }}</h1>
          <p class="brand-desc">万种游戏玩法 · 应有尽有</p>
        </div>
      </div>
      <!-- 登录内容 -->
      <div class="login-content">
        <h2 class="login-title">账号登录</h2>
        <!-- 登录表单 -->
        <div class="login-form">
          <!-- 用户名 -->
          <div class="login-group">
            <label class="input-label">
              <i class="input-icon user-icon"></i>用户名
            </label>
            <input v-model="loginInfo.name" type="text" placeholder="请输入手机号或用户名" maxlength="13" class="input-style"/>
          </div>
          <!-- 密码 -->
          <div class="login-group">
            <label class="input-label">
              <i class="input-icon lock-icon"></i>密码
            </label>
            <input v-model="loginInfo.password" type="password" placeholder="请输入8-16位密码" maxlength="16" class="input-style"/>
          </div>
          <!-- 验证码 -->
          <div class="login-group">
            <label class="input-label">
              <i class="input-icon code-icon"></i>验证码
            </label>
            <div class="captcha-wrap">
              <input v-model="loginInfo.code" type="text" placeholder="请输入验证码" maxlength="4" class="input-style captcha-inpt"/>
              <canvas ref="captchaCanvas" width="100" height="36" class="captcha-code" @click="generateCaptcha" title="点击刷新验证码"></canvas>
            </div>
          </div>
          <!-- 记住账号 -->
          <div class="login-extra">
            <label class="remember-label">
              <input type="checkbox" v-model="rememberMe" class="remember-checkbox"/>记住账号（7天）
            </label>
            <span class="forget-link" @click="$parent.openKefu()">忘记账号/密码？</span>
          </div>
        </div>
        <!-- 登录按钮 -->
        <div class="loginBtn" @click="login">
          <span>登录账号</span>
        </div>
        <!-- 备注 -->
        <p class="notes">
          <i class="icon-shield"></i>
          {{ $store.state.appInfo.title }}支持数字币存取 
          <span class="highlight-text">安全•便捷•秒到账</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      loginInfo: { name: '', password: '', code: '' },
      captchaValue: '',
      rememberMe: true
    };
  },
  created() {
    const saved = localStorage.getItem('savedLoginName');
    if(saved) { this.loginInfo.name = saved; this.rememberMe = true; }
    this.$nextTick(() => this.generateCaptcha());
  },
  watch: {
    rememberMe(val) {
      if(val && this.loginInfo.name) localStorage.setItem('savedLoginName', this.loginInfo.name);
      else localStorage.removeItem('savedLoginName');
    }
  },
  methods: {
    generateCaptcha() {
      var canvas = this.$refs.captchaCanvas;
      if (!canvas) return;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // 背景渐变
      var bgGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      bgGradient.addColorStop(0, '#f8fafc');
      bgGradient.addColorStop(1, '#f1f5f9');
      ctx.fillStyle = bgGradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 生成固定4位验证码
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
      var length = 4; // 这里固定4位
      var captcha = '';
      for (var i = 0; i < length; i++) {
        captcha += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.captchaValue = captcha;
      // 绘制验证码
      ctx.font = 'bold 18px "Arial", "Microsoft YaHei", sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      for (var i = 0; i < captcha.length; i++) {
        var x = 20 + i * 20;
        var y = canvas.height / 2 + (Math.random() * 10 - 5);
        var rotate = (Math.random() * 40 - 20) * Math.PI / 180;
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rotate);
        ctx.fillStyle = '#165DFF';
        ctx.fillText(captcha[i], 0, 0);
        ctx.restore();
      }
    },
    login() {
      if(!this.loginInfo.name || !this.loginInfo.password){ this.$parent.showTost(0,'请输入账号和密码'); return; }
      if(!this.loginInfo.code){ this.$parent.showTost(0,'请输入验证码'); return; }
      if(this.loginInfo.code.toUpperCase() !== this.captchaValue.toUpperCase()){ 
        this.$parent.showTost(0,'验证码错误'); this.loginInfo.code=''; this.generateCaptcha(); return; 
      }
      this.$parent.showLoading();
      this.$apiFun.login({name:this.loginInfo.name,password:this.loginInfo.password})
        .then(res=>{
          this.$parent.hideLoading();
          if(res.code!==200){ this.$parent.showTost(0,res.message); this.loginInfo.code=''; this.generateCaptcha(); return; }
          if(this.rememberMe) localStorage.setItem('savedLoginName',this.loginInfo.name);
          else localStorage.removeItem('savedLoginName');
          sessionStorage.setItem('token',res.data.api_token);
          this.$store.commit('changToken');
          this.$parent.getUserInfo();
        })
        .catch(()=>{ this.$parent.hideLoading(); this.$parent.showTost(0,'网络异常'); });
    }
  }
};
</script>

<style scoped lang="scss">
.login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  position: relative;
  background: #fff;

  .login-bg-decoration {
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: 0.04;
    z-index: 0;
  }

  .container {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
  }

  .login-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .close {
      width: 28px;
      height: 28px;
      cursor: pointer;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="%23165DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18L9 12L15 6"/></svg>');
      background-repeat: no-repeat;
      background-position: center;
    }

    .register-btn {
      padding: 6px 16px;
      border-radius: 20px;
      border: 1px solid #165DFF;
      color: #165DFF;
      font-size: 14px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        background: #f0f7ff;
      }
    }
  }

  .login-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;

    .brand-logo {
      width: 60px;
      height: 60px;
      margin-bottom: 12px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .brand-name {
      font-size: 22px;
      color: #165DFF;
      font-weight: 600;
      text-align: center;
      margin-bottom: 4px;
    }

    .brand-desc {
      font-size: 13px;
      color: #9ca3af;
      text-align: center;
    }
  }

  .login-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .login-title {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 8px;
    }

    .login-form {
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      border: 1px solid #f3f4f6;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      gap: 16px;

      .login-group {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .input-label {
          font-size: 14px;
          color: #4b5563;
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 500;
        }

        .input-style {
          height: 42px;
          padding: 0 12px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 14px;
          background: #f9fafb;
          &:focus {
            border-color: #165DFF;
            box-shadow: 0 0 0 3px rgba(22, 93, 255, 0.1);
            background: #fff;
          }
        }

        .captcha-wrap {
          display: flex;
          align-items: center;
          gap: 8px;

          .captcha-inpt {
            flex: 1;
			width: 80px;
          }

          .captcha-code {
            width: 100px;
            height: 42px;
            cursor: pointer;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
          }
        }
      }

      .login-extra {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;

        .remember-label {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .forget-link {
          cursor: pointer;
          color: #165DFF;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .loginBtn {
      width: 100%;
      height: 46px;
      border-radius: 8px;
      background: linear-gradient(90deg, #165DFF, #36BFFA);
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        background: linear-gradient(90deg, #0e42c3, #2aa2e6);
      }
    }
    .notes {
      text-align: center;
      font-size: 12px;
      color: #9ca3af;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      .highlight-text {
        color: #165DFF;
        font-weight: 500;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main/login.vue